const careers = [
     /*
    {
        id: 1,
        title: `Delivery Driver`,
        description: `Join our team as a Delivery Driver and play a crucial role in ensuring our customers receive their orders promptly and with a smile. Enjoy the freedom of being on the road while providing exceptional service to our valued customers.`
    }
    , {
        id: 2,
        title: `Customer Service Representative`,
        description: `Are you a problem solver with excellent communication skills? Join our Customer Service team to assist customers, answer inquiries, and ensure a seamless experience. Help us maintain our reputation for outstanding customer support.`
    }
    , {
        id: 3,
        title: `Restaurant Partnerships Manager`,
        description: `Forge strong relationships with local restaurants as a Restaurant Partnerships Manager. Collaborate to onboard new partners, drive growth, and create mutually beneficial partnerships that enhance our food delivery ecosystem.`
    }
    , {
        id: 4,
        description: `Develop innovative solutions that power our user-friendly platforms as a Software Engineer. Join a dynamic team to code, create, and optimize applications that connect our hungry customers with their favorite meals.`,
        title: `Software Engineer`
    }
    , {
        id: 5,
        title: `Marketing Specialist`,
        description: `As a Marketing Specialist, dive into the exciting world of digital marketing. Craft engaging content, devise campaigns, and drive brand engagement, while promoting our food delivery services to a hungry audience.`
    }
    , {
        id: 6,
        title: `Operations Coordinator`,
        description: `Our Operations Coordinator role is perfect for those who thrive in a fast-paced environment. Manage delivery logistics, ensure timely order fulfillment, and work closely with teams to keep our operations running smoothly.`
    }
    , {
        id: 7,
        title: `UX/UI Designer`,
        description: `If you're passionate about design and user experience, join us as a UX/UI Designer. Shape intuitive and visually appealing interfaces, transforming user interactions into delightful and seamless journeys.`
    }
    , {
        id: 8,
        title: `Data Analyst`,
        description: `Join our Data Analyst team to uncover insights from data. Analyze user behavior, trends, and performance metrics to drive informed decisions that elevate our food delivery services to the next level.`
    }
    , {
        id: 9,
        title: `Content Writer`,
        description: `As a Content Writer, bring our brand to life through words. Craft compelling narratives, engaging blog posts, and persuasive marketing copy that resonate with our customers' appetites and preferences.`
    }
    , {
        id: 10,
        title: `Finance and Accounting Manager`,
        description: `Play a vital role in our financial operations as a Finance and Accounting Manager. Ensure financial integrity, oversee budgets, and collaborate with teams to ensure our financial strategies align with our growth ambitions.`
    }
    , {
        id: 11,
        title: `HR and Recruitment Specialist`,
        description: `Join our HR team as a Recruitment Specialist to attract top talent. Manage the recruitment process, support employees, and foster a positive work culture, contributing to our company's success and growth.`
    }
    , {
        id: 12,
        title: `Quality Assurance Tester`,
        description: `Ensure our platforms are flawless as a Quality Assurance Tester. Work meticulously to identify and report bugs, ensuring our customers have a seamless experience when using our food delivery services.`
    }
     */
]

export default careers;